import { catchError, Observable, throwError } from 'rxjs';
import { CatchErrorReturnType } from '@web/utils';
import { isUnprocessableEntity } from './is-unprocessable-entity';
import { HttpErrorResponse } from '@angular/common/http';

export const catchIfUnprocessableEntity = <T, O>(
  fn: (response: HttpErrorResponse) => Observable<O>,
): CatchErrorReturnType<T, O> => {
  return catchError((response) => {
    if (isUnprocessableEntity(response)) {
      return fn(response);
    }

    return throwError(() => response);
  });
};
